import { withPrefix } from 'gatsby';
import styled, { css, down } from '@xstyled/styled-components';

export const Article = styled.article`
  code {
    background-color: background-light;
    color: on-background-primary;
    border-radius: base;
    padding: 0 1;
  }

  mark {
    background-color: background-mark;
  }

  > p {
    margin: 4 0;
    line-height: relaxed;
    font-size: lg;

    ${down(
      'lg',
      css`
        font-size: 14px;
      `
    )}
  }

  > hr {
    margin: 0;
    height: 0;
    border: 0;
    border-top: 1;
    border-color: layout-border;
    margin: 4 0;

    &:first-child {
      margin-top: 0;
    }
  }

  > h1 {
    font-size: 24px;
    line-height: 28px;
    font-weight: bold;
    margin-top: -16;
    padding-top: 24;
    margin-bottom: 4;
    padding-bottom: 4;
    border-bottom: 1px solid #7b99a1;
    color: #4ca48a;

    ${down(
      'lg',
      css`
        font-size: 18px;
        line-height: 21px;
      `
    )}
  }

  > h2 {
    font-size: xl;
    line-height: tight;
    font-weight: bold;
    margin: 4 0;

    ${down(
      'lg',
      css`
        font-size: 17px;
      `
    )}
  }

  a {
    color: primary;
    text-decoration: underline;
    font-weight: bold;

    &:hover,
    &:focus {
      color: primary;
    }

    ${down(
      'lg',
      css`
        font-size: 14px;
      `
    )}
  }

  h1,
  h2,
  h3 {
    display: flex;
    align-items: center;
  }

  > h3 {
    font-size: 18;
    line-height: 1.2;
    font-weight: 600;
    margin: 4 0 3;

    ${down(
      'lg',
      css`
        font-size: 16px;
      `
    )}

    ${down(
      'sm',
      css`
        overflow-wrap: break-word;
        word-break: break-word;
      `
    )}
  }

  > h4 {
    font-weight: 500;
    font-size: 16;
    line-height: 1.2;
    margin: 3 0;
  }

  > h4 + p {
    margin-top: 3;
  }

  > ul + p {
    margin-top: 2;
  }

  .editor {
    background-color: editor-background;
    color: editor-text;
    padding: 3 4;
    margin: 4 -3;
    overflow: auto;
    font-size: 14;
    line-height: 1.45;
    border-radius: base;

    ${down(
      'sm',
      css`
        margin-left: -4;
        margin-right: -4;
        border-radius: 0;
      `
    )}
  }

  > code {
    background-color: editor-background;
    border-radius: base;
    color: inherit;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono,
      Courier New, monospace;
    font-size: 85%;
    padding: 1 2;
  }

  img {
    max-width: 100%;
  }

  ol,
  ul {
    margin-top: 4;
    font-size: 16;
    padding-left: 4;

    ${down(
      'lg',
      css`
        font-size: 14px;
      `
    )}

    p,
    p:first-of-type {
      font-size: 16;
      margin-top: 0;
      line-height: 1.2;
      ${down(
        'lg',
        css`
          font-size: 14px;
        `
      )}
    }

    li {
      margin-top: 2;
    }

    ol,
    ul {
      margin-left: 4;
      margin-top: 2;
    }
  }
  ol {
    p,
    p:first-of-type {
      margin: 16px 0px;
    }
  }

  ol {
    list-style: decimal;
  }

  ul {
    list-style: disc;
  }

  > blockquote {
    font-size: 16;
    background-color: blockquote-background;
    padding: 4 5;
    margin: 4 0;
    border-radius: base;
    border: 1px solid #e3720e;

    ${down(
      'lg',
      css`
        font-size: 14px;
      `
    )}

    code {
      background-color: rgba(255, 255, 255, 0.1);
      background-blend-mode: color;
      color: on-background;
      border-radius: base;
      padding: 0 1;
    }

    p {
      margin-top: 3;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      transition: fast;
      color: blockquote-link;
      text-decoration: underline;

      &:hover {
        color: on-background;
      }
    }
  }

  .anchor {
    float: none;
    padding-right: 4px;
    margin-left: 2;
    order: 2;
    display: flex;

    svg {
      display: none;
    }

    &:before {
      display: block;
      content: ' ';
      background-image: url(${withPrefix('images/anchor.svg')});
      width: 16px;
      height: 16px;
      opacity: 0.25;
    }

    &:hover {
      &:before {
        opacity: 1;
      }
    }
  }
`;
